import React, { createContext, useCallback, useContext, useEffect, useRef, useState } from 'react';
import { api } from '../api/client';
import { useUI } from './UIContext';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const { notify } = useUI();
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const authVersion = useRef(0);

  useEffect(() => {
    const version = authVersion.current;
    api.getMe()
      .then(data => { if (authVersion.current === version) setUser(data); })
      .catch(() => { if (authVersion.current === version) setUser(null); })
      .finally(() => setLoading(false));
  }, []);

  const login = useCallback((userData) => {
    authVersion.current += 1;
    setUser(userData);
  }, []);

  useEffect(() => {
    if (!user?.id) return undefined;
    let active = true;
    const timer = setInterval(() => {
      if (document.hidden) return;
      api.getMe().then(data => { if (active) setUser(data); })
        .catch(() => { console.warn('auth.status_refresh_failed'); });
    }, 5000);
    return () => { active = false; clearInterval(timer); };
  }, [user?.id]);

  const logout = useCallback(async () => {
    try {
      await api.logoutUser();
      authVersion.current += 1;
      setUser(null);
    } catch {
      notify('Не удалось выйти. Проверьте соединение и попробуйте ещё раз.');
    }
  }, [notify]);

  return (
    <AuthContext.Provider value={{ user, loading, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
